import React from "react";
import { Grid as Grid, Typography, Button } from "@mui/material";
import BuildIDLogo from "../../assets/images/build_id_logo.png";
import { BIBlue } from "../../assets/helpers";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setLogindata, setSelectedClientdata } from "../../redux/actions/actions";
import OnboardingWizard from "./OnboardingWizard";
import { useState } from "react";
import { GETUSERINFO } from "../../constant/Apipath";
import BuilderIcon from "../../assets/images/profile_logo.jpg";
import { Getrequestcall } from "../../request/Getrequest";
import { useNavigate } from "react-router";

export const FinishPage = () => {
  const [openTour, setOpenTour] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const rawLoginData = useSelector((state) => state.main?.loginData);
  const { sourceDataFrom, ...filteredLoginData } = rawLoginData || {};

  const handleExploreClick = () => {
    setOpenTour(true);
  };
  const handleGoToAppClick = () => {
    getUserinformation(filteredLoginData);
    // dispatch(setLogindata(filteredLoginData));
    // window.location.replace("/home");
    // navigate("/");
  };

  const getUserinformation = async (loginRes) => {
    let getResponse = await Getrequestcall(
      `${GETUSERINFO}/${loginRes?.userInformation?.UserId}`,
      loginRes?.accessToken
    );
    if (getResponse?.status === 200) {
      let getDetail = getResponse?.data?.data;
      let getClientlist = loginRes?.userInformation?.ClientsList?.filter(
        (item) => item?.InvitationStatus === "Accepted" && item?.ClientEmployeeId !== 0
      );

      const buildIDObj = {
        ClientId: 0,
        AccentColor: BIBlue,
        OrganizationName: "BuildID Free",
        ClientLogo: BuilderIcon
      };

      getClientlist.push(buildIDObj);
      let getObj = {
        ...loginRes,
        userInformation: {
          ...loginRes.userInformation,
          FirstName: getDetail?.firstName,
          LastName: getDetail?.lastName,
          TradeName: getDetail?.tradeName,
          ClientsList: getClientlist
        }
      };

      dispatch(setLogindata(getObj));
      dispatch(setSelectedClientdata(buildIDObj));
      // dispatch(getMenuCardBuilderBucks(loginRes?.userInformation?.UserId, loginRes?.accessToken));
      navigate("/home");
      // window.location.replace("/home");
    }
  };

  return (
    <>
      <Grid
        container
        className="login-form-content-width with-referral"
        sx={{ padding: "45px 0px" }}
        direction="column"
        alignItems="center">
        <Grid item container justifyContent="center" alignItems="center">
          <Grid
            item
            sx={{
              maxWidth: "90%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}>
            <img
              src={BuildIDLogo}
              alt=""
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                width: "150px",
                height: "auto"
              }}
            />
          </Grid>
        </Grid>

        <Grid item textAlign="center">
          <Typography variant="h4">You're all done!</Typography>
          <Typography variant="subtitle1">Welcome to our construction community!</Typography>
        </Grid>

        <Grid item sx={{ marginTop: "100px" }}>
          <Button
            sx={{ background: BIBlue, color: "white" }}
            variant="contained"
            onClick={handleExploreClick}>
            Explore BuildID Features
          </Button>
        </Grid>

        <Grid item sx={{ marginTop: "10px" }}>
          <Button fullWidth onClick={handleGoToAppClick} sx={{ color: BIBlue }}>
            Go to App
          </Button>
        </Grid>
      </Grid>
      {openTour && (
        <OnboardingWizard open={openTour} closeOnboarding={() => setOpenTour(false)} />
      )}
    </>
  );
};
